// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/css/style.css';
import './assets/css/payment.css';
import './assets/css/slider.css';
import './assets/css/privacy.css';
import './assets/css/publicoffer.css';

window.__STB_ASSET_RELEASE__ = 'production-pr17-assets-20260614';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
